var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g4, _path43, _g5, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _g6, _path60, _g7, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBirthdays = function SvgBirthdays(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 96,
    viewBox: "0 0 98 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.1946 82.9532C80.7604 85.4405 78.5891 86.9056 76.9206 88.0072C60.6814 98.7852 42.1222 95.6733 36.3854 94.6171C27.1287 92.9022 19.3119 91.6983 12.6036 85.6676C-2.65279 71.9708 -1.90997 43.396 9.74663 25.6901C11.1294 23.589 22.7746 6.43956 41.368 4.03182C41.8251 3.97504 42.168 3.94097 42.4651 3.90689C45.345 3.60025 63.1727 2.01023 77.7091 14.1057C79.789 15.8433 83.1375 18.9666 86.2459 23.7253C97.6054 41.17 97.6396 68.1661 83.1946 82.9532Z",
    fill: "#F4F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8022 80.2275L51.9504 85.7584C51.9504 85.7584 56.3387 82.6466 56.3616 78.3535C56.3959 69.5971 64.1098 70.2445 67.3782 70.0287C72.3151 69.7107 75.9493 67.4392 73.5265 62.726C70.7838 57.3881 78.9777 53.697 87.0116 54.3216C94.8741 54.9349 100.52 41.3971 83.6175 38.5124C73.5265 36.7861 69.161 45.7129 65.8812 49.6992C62.6013 53.6856 56.0188 49.7333 54.636 56.3773C53.4475 62.0559 54.7617 67.6664 49.9848 68.8816C45.185 70.0968 42.568 73.3223 43.8022 80.2275Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.8076 83.3734L47.0019 83.4529C47.059 83.3394 52.3388 71.6187 61.1155 61.5675C69.1951 52.3114 81.9602 42.6237 96.931 49.0292L97.011 48.8361C90.3484 45.9854 83.5602 46.0309 76.8405 48.9724C71.4693 51.3233 66.121 55.5141 60.9555 61.4313C52.1674 71.5165 46.8648 83.2599 46.8076 83.3734Z",
    fill: "#BEB8F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M74.075 50.3239L74.2578 50.4147C77.4348 44.2818 85.1144 37.7287 85.1944 37.6606L85.0573 37.5016C84.9887 37.5811 77.2748 44.1569 74.075 50.3239Z",
    fill: "#BEB8F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.6116 48.484C86.874 48.8247 91.1024 54.2308 91.1481 54.2762L91.3195 54.1513C91.2738 54.0945 86.9883 48.6203 78.6344 48.2682L78.6116 48.484Z",
    fill: "#BEB8F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.7441 68.45C63.2066 61.6925 75.606 67.2007 75.7203 67.2689L75.8346 67.0985C75.7317 67.0304 63.138 61.4767 55.6069 68.3024L55.7441 68.45Z",
    fill: "#BEB8F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.0301 64.9974L58.2243 65.0769C60.7042 59.1598 57.493 51.7663 57.4587 51.6868L57.2644 51.7663C57.3101 51.8458 60.4756 59.1712 58.0301 64.9974Z",
    fill: "#BEB8F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.8704 81.6358C50.2817 78.6602 56.4986 79.2394 56.5557 79.2508L56.5786 79.0463C56.3157 79.0236 50.1903 78.4558 47.7104 81.5108L47.8704 81.6358Z",
    fill: "#BEB8F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.0932 78.8419L49.2875 78.9327C50.556 76.1956 48.7047 70.9259 48.0876 69.1996C47.9961 68.9497 47.9276 68.7453 47.9162 68.6999L47.7104 68.7226C47.7219 68.7794 47.7676 68.9157 47.8819 69.2564C48.4876 70.9713 50.316 76.1729 49.0932 78.8419Z",
    fill: "#BEB8F2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3383 51.4255C66.1782 53.3562 65.801 55.9002 65.2296 57.6947C64.9782 57.7628 64.8639 57.865 64.624 57.99C62.5326 59.1257 61.3898 59.1598 59.1499 59.9548C58.67 60.1251 57.0929 60.1933 56.4529 60.1819L55.253 60.1365C55.253 60.1365 51.6074 55.2188 54.1787 52.8565C56.75 50.4942 53.8816 45.3948 52.7045 42.4987C51.9731 40.727 52.2245 39.6821 52.0531 38.9893C50.3503 31.6299 47.5162 30.1307 48.4419 27.405C49.459 24.3953 53.1959 25.3607 54.4759 22.1352C55.9272 18.5009 52.1331 14.8212 54.2816 11.6866C54.6473 11.1528 55.0473 10.6076 55.7787 10.142C57.5957 8.98356 59.5385 9.66499 60.4756 7.63205C62.3612 3.54345 66.7153 1.04486 70.578 3.6343C74.3949 6.18968 73.0921 13.7649 66.3724 21.4311C62.2241 27.4277 62.5441 28.7792 63.9954 31.9024C65.0125 34.083 69.2295 39.3414 66.601 42.6464C64.0068 45.9513 62.2469 49.2222 64.3383 51.4255Z",
    fill: "url(#paint1_linear)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60.3727 59.705L60.2013 59.7277C60.0413 58.7737 59.8927 57.8197 59.7556 56.877C58.7613 49.9037 58.4985 43.078 59.0013 36.6044C59.4242 31.1188 60.3841 25.8036 61.8698 20.8064C63.0583 16.786 64.5896 12.9586 66.4181 9.40379C67.7095 6.92791 69.1266 4.59968 70.6351 2.50995C70.8979 2.14652 71.195 1.78309 71.4693 1.44237C71.8464 0.976722 72.235 0.499718 72.555 0L72.7035 0.0795006C72.3721 0.579219 71.9836 1.06758 71.6064 1.53323C71.3207 1.87394 71.035 2.23737 70.7722 2.60081C69.2637 4.69054 67.8466 7.00741 66.5667 9.48329C64.7382 13.0154 63.2183 16.8428 62.0298 20.8519C60.5555 25.8377 59.5842 31.1415 59.1613 36.6157C58.6699 43.078 58.9213 49.8923 59.9156 56.8543C60.0641 57.8083 60.2127 58.7623 60.3727 59.705Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60.5098 26.9961L60.3383 26.9734C61.5269 20.1137 55.3557 9.76723 55.2986 9.66501L55.4471 9.58551C55.5157 9.68773 61.7097 20.0796 60.5098 26.9961Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.9898 46.4397H58.8184C59.0355 41.6924 66.7837 35.9229 66.8637 35.8661L66.9665 35.9911C66.898 36.0479 59.2069 41.7719 58.9898 46.4397Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.1156 49.1428L58.9441 49.1655C58.487 46.099 56.0985 42.1808 52.2016 38.1035C52.0073 37.8991 52.0073 37.8991 51.9958 37.865L52.1673 37.8423L52.0758 37.8537L52.1558 37.8082C52.1673 37.8196 52.2358 37.8991 52.3273 37.99C56.2471 42.0899 58.6584 46.0536 59.1156 49.1428Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60.1097 57.9673L59.9382 57.9446C60.5096 54.5602 65.2637 51.9707 65.3094 51.948L65.4008 52.0843C65.3437 52.107 60.6696 54.6737 60.1097 57.9673Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60.1214 59.7958C58.6814 57.4108 56.4529 55.3325 53.2874 53.4472L53.3788 53.3109C56.5672 55.2075 58.8186 57.2973 60.2699 59.7163L60.1214 59.7958Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.5381 11.5844L65.3667 11.5503C66.2581 7.76834 66.2467 3.6116 66.2467 2.24873C66.2467 1.91937 66.2467 1.8058 66.2581 1.76037L66.4295 1.78308C66.4295 1.81715 66.4295 1.99887 66.4295 2.23737C66.4295 3.62295 66.4409 7.79106 65.5381 11.5844Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.1041 17.5583L62.9556 17.4788C64.8869 14.2988 72.4637 12.2658 72.7837 12.1863L72.8294 12.3453C72.7494 12.368 65.0012 14.4351 63.1041 17.5583Z",
    fill: "#FCFDFE"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3384 76.843C63.7327 76.843 64.0756 73.6857 61.87 69.9719C61.3214 69.0406 58.6701 63.7709 54.2246 64.1343C53.3675 64.2024 52.499 64.2706 51.6305 64.3501C50.6591 62.5216 50.0877 60.6135 52.6133 59.5687C56.5217 57.956 55.7331 51.2325 54.3046 48.9951C52.5333 46.2239 48.5563 39.6822 54.556 37.0927C59.5615 34.9348 63.2528 34.5033 62.7842 28.1773C62.3157 21.8513 65.447 17.5015 71.5724 17.1608C78.0178 16.8087 82.2004 8.19991 87.8001 10.2556C97.5597 13.8331 91.1257 28.6656 80.5548 33.9808C69.9839 39.296 76.8521 42.3057 77.8463 47.4164C77.9149 47.8934 77.972 48.643 77.8806 49.5402C77.2978 55.0599 71.7552 56.6499 68.2354 61.5335C63.4356 68.1888 65.3669 76.8544 64.3384 76.843Z",
    fill: "url(#paint2_linear)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.4355 62.9304L59.127 62.9077C60.864 42.0899 73.3549 22.1693 91.7311 10.9143L91.9025 11.1528C73.5948 22.3624 61.1611 42.2035 59.4355 62.9304Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M61.4126 51.6527L61.1155 51.6868C60.0641 43.5436 51.8017 38.0467 51.7217 37.9899L51.8931 37.7514C51.9731 37.8196 60.3384 43.3846 61.4126 51.6527Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.8697 59.103L59.584 59.0008C62.8181 51.2552 78.6802 48.4045 78.8402 48.3818L78.8974 48.6657C78.7374 48.6884 63.0467 51.5164 59.8697 59.103Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.858 32.7996L69.5609 32.7201C71.5608 26.3942 66.1782 17.6264 66.1211 17.5355L66.3839 17.3879C66.4525 17.4788 71.9036 26.3487 69.858 32.7996Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.269 22.1352L78.0747 21.9081C84.3487 17.2289 95.1253 18.1829 95.2396 18.1943L95.2053 18.4782C95.1025 18.4782 84.4401 17.5242 78.269 22.1352Z",
    fill: "#FCFDFE"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8123 87.7914L20.5691 91.6074V17.0472L73.8123 19.0574V87.7914Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9151 85.236L25.3918 88.8022V14.6395L77.9151 16.9563V85.236Z",
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.3276 86.9623L25.7348 89.3587L25.5291 15.1619L44.4196 15.6389C40.7284 22.3851 36.6828 28.3363 49.5737 40.9655C62.6931 53.7992 67.9385 73.4245 56.3276 86.9623Z",
    fill: "#D8DEE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M43.0824 35.5368L35.677 35.6163L35.6999 27.5754H43.0938L43.0824 35.5368Z",
    fill: "url(#paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M71.5039 31.38L45.448 31.539L45.4594 27.564L71.5039 27.5413V31.38Z",
    fill: "url(#paint6_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M43.0481 51.6072L35.6313 51.8457L35.6542 43.7935L43.0596 43.6231L43.0481 51.6072Z",
    fill: "url(#paint7_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M71.4924 46.8486L45.4136 47.5527L45.425 43.5777L71.4924 43.0098V46.8486Z",
    fill: "url(#paint8_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M43.0025 67.7118L35.5857 68.1093L35.6086 60.0343L43.0253 59.7163L43.0025 67.7118Z",
    fill: "url(#paint9_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M71.4925 62.3512L45.3909 63.6118V59.6255L71.4925 58.5011V62.3512Z",
    fill: "url(#paint10_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5575 89.5063C23.3461 89.9038 24.3289 89.5404 24.7631 88.6886C25.1974 87.8368 24.9117 86.8374 24.1232 86.4399C24.0774 86.4172 24.0432 86.4058 23.9975 86.3831C24.146 85.9175 24.2489 85.4405 24.3289 84.9748C24.3746 84.9748 24.4203 84.9748 24.466 84.9748C25.3688 84.8953 26.0774 84.0776 26.0545 83.1463C26.0316 82.215 25.2888 81.5222 24.3974 81.6017C24.3517 81.6017 24.306 81.6131 24.2603 81.6244C24.1689 81.1588 24.0432 80.7158 23.8717 80.2729C23.9175 80.2502 23.9517 80.2275 23.9975 80.1934C24.7631 79.6596 25.0145 78.6034 24.546 77.8311C24.0774 77.0588 23.0832 76.8771 22.3175 77.4109C22.2832 77.4336 22.2375 77.4677 22.2033 77.5018C21.8947 77.1724 21.5633 76.8544 21.209 76.5818C21.2319 76.5364 21.2547 76.5023 21.2776 76.4569C21.7118 75.6051 22.2718 74.6852 21.4833 74.299C19.6434 73.4132 18.8663 74.1741 18.432 75.0145C18.4091 75.06 18.3863 75.1054 18.3749 75.1508C17.9292 75.0259 17.4835 74.9464 17.0378 74.901C17.0378 74.8555 17.0378 74.8101 17.0378 74.7533C17.0149 73.822 17.3006 73.3223 16.3978 73.2996C14.4322 73.2655 13.7694 74.1059 13.7922 75.0372C13.7922 75.0827 13.7922 75.1281 13.8037 75.1849C13.358 75.3098 12.9123 75.4802 12.478 75.6732C12.4551 75.6278 12.4323 75.5937 12.4094 75.5483C11.9409 74.776 10.9466 74.5943 10.181 75.1281C9.41529 75.6619 9.16387 76.7181 9.63242 77.4904C9.65528 77.5245 9.67814 77.5699 9.71242 77.604C9.36958 77.9447 9.04959 78.3081 8.76389 78.7056C8.72961 78.6829 8.6839 78.6602 8.64961 78.6375C7.86108 78.24 6.87827 78.6034 6.444 79.4552C6.00974 80.307 6.29544 81.3064 7.08397 81.7039C7.12969 81.7266 7.16397 81.738 7.20968 81.7607C7.06112 82.2264 6.95827 82.7034 6.87827 83.169C6.83256 83.169 6.78684 83.169 6.74113 83.169C5.83832 83.2485 5.12978 84.0662 5.15264 84.9975C5.17549 85.9288 5.91832 86.6216 6.8097 86.5421C6.85541 86.5421 6.90113 86.5307 6.94684 86.5194C7.03826 86.985 7.16397 87.428 7.33539 87.8709C7.28968 87.8936 7.25539 87.9163 7.20968 87.9504C6.444 88.4842 6.19259 89.5404 6.66114 90.3127C7.12969 91.085 8.66104 91.4371 9.43815 90.9033C9.47243 90.8806 8.9696 90.6761 9.01531 90.6534C9.32387 90.9828 9.65528 91.3008 10.0095 91.5734C9.98669 91.6188 9.96384 91.6529 9.94098 91.6983C9.50671 92.5501 9.79242 93.5495 10.5809 93.947C11.3695 94.3445 12.3523 93.9811 12.7866 93.1293C12.8094 93.0839 12.8323 93.0384 12.8437 92.993C13.2894 93.1179 13.7351 93.1974 14.1808 93.2429C14.1808 93.2883 14.1808 93.3337 14.1808 93.3905C14.2036 94.3218 14.9465 95.0146 15.8378 94.9351C16.7407 94.8556 17.4492 94.0379 17.4263 93.1066C17.4263 93.0611 17.4263 93.0157 17.4149 92.9589C17.8606 92.834 18.3063 92.6637 18.7406 92.4706C18.7634 92.516 18.7863 92.5501 18.8091 92.5955C19.2777 93.3678 20.2719 93.5495 21.0376 93.0157C21.8033 92.4819 22.0547 91.4257 21.5861 90.6534C21.5633 90.6194 21.5404 90.5739 21.5061 90.5398C21.849 90.1991 22.169 89.8357 22.4547 89.4382C22.4775 89.4609 22.5118 89.4836 22.5575 89.5063ZM12.7408 89.6313C9.88384 88.1889 8.84389 84.5319 10.4095 81.4541C11.9752 78.3763 15.5636 77.0588 18.4206 78.5012C21.2776 79.9436 22.3175 83.6006 20.7519 86.6784C19.1863 89.7448 15.5979 91.0736 12.7408 89.6313Z",
    fill: "url(#paint11_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.466 84.9635C25.3688 84.884 26.0774 84.0662 26.0545 83.135C26.0317 82.2037 25.2888 81.5109 24.3975 81.5904C24.3518 81.5904 24.306 81.6017 24.2603 81.6131C24.1689 81.1474 24.0432 80.7045 23.8718 80.2616C23.9175 80.2389 23.9518 80.2161 23.9975 80.1821C24.7632 79.6483 25.7117 78.3535 25.1746 77.638C24.146 76.2752 23.0832 76.8658 22.3176 77.3995C22.2833 77.4223 22.2376 77.4563 22.2033 77.4904C21.8947 77.161 21.5633 76.843 21.209 76.5705C21.2319 76.525 21.2548 76.491 21.2776 76.4455C21.5176 75.9799 21.529 75.4802 21.3805 75.0486C20.6376 76.3433 19.9062 77.6494 19.1863 78.9555C21.4605 80.6136 22.1919 83.8845 20.7633 86.6784C19.552 89.0407 17.1521 90.3695 14.8093 90.1992C14.7065 90.4717 14.6036 90.7443 14.4894 91.0055C14.1808 91.7324 13.838 92.4365 13.4951 93.152C13.7122 93.1975 13.9294 93.2202 14.1465 93.2429C14.1465 93.2883 14.1465 93.3338 14.1465 93.3905C14.1694 94.3218 14.7293 95.1168 16.3636 95.026C17.2664 94.9806 17.4149 94.0266 17.4035 93.0953C17.4035 93.0498 17.4035 93.0044 17.3921 92.9476C17.8378 92.8227 18.2835 92.6523 18.7177 92.4592C18.7406 92.5047 18.7634 92.5388 18.7863 92.5842C19.2548 93.3565 20.8662 93.6745 21.6319 93.1407C22.3976 92.6069 22.0319 91.4144 21.5633 90.6421C21.5405 90.608 21.5176 90.5626 21.4833 90.5285C21.8262 90.1878 22.1461 89.8244 22.4318 89.4269C22.4661 89.4496 22.5118 89.4723 22.5461 89.495C23.3347 89.8925 24.3175 89.5291 24.7517 88.6773C25.186 87.8255 24.9003 86.8261 24.1118 86.4286C24.066 86.4058 24.0318 86.3945 23.9861 86.3718C24.1346 85.9061 24.2375 85.4291 24.3175 84.9635C24.3746 84.9748 24.4203 84.9748 24.466 84.9635Z",
    fill: "url(#paint12_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4032 89.5972C24.1918 89.9947 25.1746 89.6313 25.6088 88.7795C26.0431 87.9277 25.7574 86.9282 24.9689 86.5307C24.9232 86.508 24.8889 86.4967 24.8432 86.4739C24.9917 86.0083 25.0946 85.5313 25.1746 85.0657C25.2203 85.0657 25.266 85.0657 25.3117 85.0657C26.2145 84.9862 26.9231 84.1684 26.9002 83.2371C26.8774 82.3059 26.1345 81.6131 25.2432 81.6926C25.1974 81.6926 25.1517 81.7039 25.106 81.7153C25.0146 81.2496 24.8889 80.8067 24.7175 80.3638C24.7632 80.341 24.7975 80.3183 24.8432 80.2843C25.6088 79.7505 25.8603 78.6943 25.3917 77.922C24.9232 77.1497 23.9289 76.968 23.1632 77.5018C23.129 77.5245 23.0833 77.5585 23.049 77.5926C22.7404 77.2632 22.409 76.9452 22.0547 76.6727C22.0776 76.6272 22.1004 76.5932 22.1233 76.5477C22.5576 75.696 22.2719 74.6965 21.4833 74.299C20.6948 73.9015 19.712 74.2649 19.2777 75.1167C19.2549 75.1622 19.232 75.2076 19.2206 75.253C18.7749 75.1281 18.3292 75.0486 17.8835 75.0032C17.8835 74.9577 17.8835 74.9123 17.8835 74.8555C17.8606 73.9242 17.1178 73.2314 16.2264 73.3109C15.3236 73.3904 14.6151 74.2082 14.6379 75.1394C14.6379 75.1849 14.6379 75.2303 14.6494 75.2871C14.2037 75.412 13.758 75.5824 13.3237 75.7755C13.3009 75.73 13.278 75.696 13.2551 75.6505C12.7866 74.8782 11.7924 74.6965 11.0267 75.2303C10.261 75.7641 10.0096 76.8203 10.4781 77.5926C10.501 77.6267 10.5238 77.6721 10.5581 77.7062C10.2153 78.0469 9.8953 78.4103 9.6096 78.8078C9.57531 78.7851 9.5296 78.7624 9.49532 78.7397C8.70678 78.3422 7.72397 78.7056 7.28971 79.5574C6.85544 80.4092 7.14114 81.4086 7.92968 81.8061C7.97539 81.8288 8.00967 81.8402 8.05539 81.8629C7.90682 82.3286 7.80397 82.8056 7.72397 83.2712C7.67826 83.2712 7.63255 83.2712 7.58684 83.2712C6.68402 83.3507 5.97548 84.1684 5.99834 85.0997C6.0212 86.031 6.76402 86.7238 7.65541 86.6443C7.70112 86.6443 7.74683 86.6329 7.79254 86.6216C7.88397 87.0872 8.00967 87.5302 8.18109 87.9731C8.13538 87.9958 8.1011 88.0185 8.05539 88.0526C7.28971 88.5864 7.03829 89.6426 7.50684 90.4149C7.97539 91.1872 8.96963 91.3689 9.73531 90.8351C9.76959 90.8124 9.8153 90.7783 9.84959 90.7443C10.1581 91.0736 10.4896 91.3916 10.8438 91.6642C10.821 91.7096 10.7981 91.7437 10.7753 91.7891C10.341 92.6409 10.6267 93.6403 11.4152 94.0378C12.2038 94.4354 13.1866 94.0719 13.6208 93.2201C13.6437 93.1747 13.6666 93.1293 13.678 93.0838C14.1237 93.2088 14.5694 93.2883 15.0151 93.3337C15.0151 93.3791 15.0151 93.4246 15.0151 93.4813C15.0379 94.4126 15.7807 95.1054 16.6721 95.0259C17.5749 94.9464 18.2835 94.1287 18.2606 93.1974C18.2606 93.152 18.2606 93.1066 18.2492 93.0498C18.6949 92.9248 19.1406 92.7545 19.5748 92.5614C19.5977 92.6068 19.6206 92.6409 19.6434 92.6863C20.112 93.4586 21.1062 93.6403 21.8719 93.1066C22.6376 92.5728 22.889 91.5165 22.4204 90.7443C22.3976 90.7102 22.3747 90.6648 22.3404 90.6307C22.6833 90.29 23.0033 89.9265 23.289 89.529C23.3232 89.5517 23.3575 89.5745 23.4032 89.5972ZM13.5866 89.7221C10.7295 88.2797 9.6896 84.6227 11.2552 81.5449C12.8209 78.4671 16.4093 77.1497 19.2663 78.592C22.1233 80.0344 23.1632 83.6914 21.5976 86.7692C20.032 89.847 16.4436 91.1645 13.5866 89.7221Z",
    fill: "url(#paint13_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1633 59.1598C21.6433 58.8532 21.209 57.9446 21.1747 56.0139C21.1404 53.6402 21.7804 53.1973 21.2661 52.2774C20.649 51.1416 19.0834 50.6646 18.0434 50.6533C17.8149 50.6533 17.7577 50.5284 15.8493 51.0167C12.398 51.9026 11.5295 50.9486 9.98668 51.9026C8.4896 52.8225 9.15243 53.8333 7.70107 54.9122C5.3469 56.6613 2.87844 54.776 1.19852 56.2297C-0.389978 57.6153 -0.424262 61.136 1.24423 63.0554C3.14128 65.2359 6.55827 64.5772 8.8553 64.1456C9.33528 64.0548 11.7695 63.5437 14.3065 61.6811C15.7121 60.6476 16.6721 59.5573 17.2892 58.7396C17.4378 58.5806 17.6549 58.3875 17.952 58.3535C18.3063 58.3194 18.592 58.5352 18.7291 58.626C19.4377 59.1371 20.6947 59.4665 21.1633 59.1598Z",
    fill: "url(#paint14_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9572 65.8265C26.8886 65.6334 26.8772 65.4858 26.9229 65.3609C26.8086 65.2132 26.6944 65.0769 26.6029 64.9406C25.1059 62.8509 25.2316 61.488 23.5174 59.8072C22.0546 58.3761 19.849 57.2972 19.2319 57.8537C18.4547 58.5579 20.2947 61.6925 21.6775 64.0548C23.0488 66.4057 23.7688 67.6096 25.163 68.5068C25.9858 69.0406 26.8315 69.3586 27.62 69.5517C27.5057 68.3024 27.1743 67.0758 26.9572 65.8265Z",
    fill: "url(#paint15_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1514 89.8244L31.4257 88.8022H30.6486C30.6486 88.8022 30.3858 89.7789 30.4086 89.8244C30.7515 90.3922 32.3628 90.8124 33.3685 90.8465C33.5399 90.8579 33.7685 90.8579 33.8256 90.7329C33.9513 90.5399 33.4942 90.1083 33.1514 89.8244Z",
    fill: "url(#paint16_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4028 87.6778C31.2885 88.3138 31.4371 88.6432 31.5857 88.8363C31.6885 88.9726 31.7914 89.0066 32.4199 89.5404C32.6256 89.7221 32.7399 89.813 32.7056 89.8698C32.6828 89.9266 32.4999 89.8925 32.0999 89.8016C31.2314 89.5972 30.7971 89.4836 30.6943 89.2792C30.6028 89.0975 30.6828 89.0066 30.6828 88.4956C30.6828 88.1548 30.6143 87.8936 30.5571 87.7233C30.8314 87.7005 31.1171 87.6892 31.4028 87.6778Z",
    fill: "url(#paint17_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6487 82.6352C32.6487 82.6352 33.4258 83.5551 33.3001 84.5659C33.1744 85.5767 31.8144 84.1003 31.6201 83.6006C31.4259 83.1009 31.2087 82.3854 31.2087 82.3854C31.2087 82.3854 32.1687 81.8062 32.6487 82.6352Z",
    fill: "url(#paint18_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3513 81.1929C32.3513 81.1929 32.1456 82.2718 32.5456 82.8283C32.7513 83.1122 33.0141 83.3507 32.9341 83.5779C32.877 83.7369 32.6827 83.8391 32.5113 83.8277C32.1799 83.7937 31.9971 83.2939 31.8713 82.9419C31.6771 82.4194 31.5742 81.3064 31.5742 81.3064L32.3513 81.1929Z",
    fill: "url(#paint19_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7341 82.1014C31.9741 82.0106 32.2141 81.9311 32.4541 81.8402C32.8312 80.9884 33.2769 79.6028 33.1283 77.9106C32.7398 73.5608 28.6942 71.2553 28.2485 71.0168C27.1514 71.5619 26.0315 72.3456 25.9858 73.3223C25.9401 74.5489 27.62 75.1962 29.1971 76.9907C30.1456 78.0696 31.1513 79.671 31.7341 82.1014Z",
    fill: "url(#paint20_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4712 88.1776C32.2598 85.1111 32.0541 82.6125 31.8369 81.1701C31.4941 78.9896 30.797 74.5602 27.8143 72.9021C27.1629 72.5386 26.2372 72.2206 25.1058 71.2098C24.1573 70.3694 23.563 69.4949 23.1973 68.8703C19.2204 67.7118 15.5406 68.1775 13.9178 70.3013C13.7349 70.5511 13.2664 71.0736 13.1749 71.8572C12.9692 73.6289 14.7177 75.7527 16.6834 76.207C19.1747 76.7749 20.626 74.2309 22.8316 75.0713C23.4488 75.3098 23.9744 75.9004 25.0258 77.0702C26.3629 78.5693 27.1057 79.9436 27.3914 80.5001C28.2371 82.1469 28.8771 83.3507 28.9685 84.9294C28.9913 85.2928 29.0028 86.031 29.437 86.8374C29.7685 87.4507 30.2141 87.8596 30.557 88.1094C30.8541 88.1321 31.1627 88.1548 31.4712 88.1776Z",
    fill: "url(#paint21_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.1634 71.8686C13.2548 71.0849 13.7234 70.5511 13.9062 70.3126C15.529 68.1888 19.1974 67.7232 23.1858 68.8816C23.5515 69.5063 24.1457 70.3808 25.0942 71.2212C26.2256 72.2206 27.1513 72.55 27.8027 72.9134C29.6197 73.9242 30.5911 75.9685 31.1511 77.8993C30.3283 76.6272 29.6197 76.2865 29.0712 76.2752C28.2827 76.2638 27.9398 76.9339 27.0027 76.843C25.9971 76.7408 25.7685 75.9231 24.9571 75.8322C24.7171 75.8095 24.42 75.8436 24.0543 76.0367C23.5743 75.5369 23.22 75.2417 22.8201 75.094C20.6145 74.2422 19.1631 76.7976 16.6718 76.2297C14.7176 75.7641 12.9577 73.6403 13.1634 71.8686Z",
    fill: "url(#paint22_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4143 74.2763C28.9686 74.2536 28.2715 74.2422 27.4372 74.3217C23.4603 74.7079 22.3632 76.6613 19.0833 77.1383C18.3062 77.2519 14.8435 77.7516 13.3465 75.7641C12.2722 74.3331 12.4322 71.8799 13.6093 70.9146C14.1121 70.5057 14.6036 70.5171 17.792 70.5398C18.9919 70.5511 20.1919 70.5511 21.3918 70.5739C26.4773 70.642 27.4487 70.2899 28.3743 71.119C28.7972 71.5165 29.4257 72.3569 29.4143 74.2763Z",
    fill: "url(#paint23_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6834 58.0695C18.6834 58.0695 12.7523 56.3546 12.1352 60.6703C11.5409 64.8044 14.5693 66.701 13.1866 70.8918C13.0266 71.3802 24.4774 69.1542 24.4774 69.1542C22.9461 67.2575 22.5918 65.7016 22.5575 64.6113C22.5118 63.4188 22.8661 62.8736 22.5575 61.4653C22.5575 61.4653 22.2147 59.898 20.9919 58.5465C20.8091 58.3421 20.6033 58.149 18.6834 58.0695Z",
    fill: "url(#paint24_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3919 55.4801C17.449 55.73 17.7233 57.0815 17.1633 57.4336C17.0376 57.5131 16.809 57.5471 16.3405 57.638C16.0319 57.6948 15.7805 57.7289 15.5977 57.7516C15.6205 57.9787 15.7005 58.3535 15.9634 58.6829C16.7062 59.6255 18.1804 59.3757 18.3975 59.3416C19.1403 59.2053 19.8717 58.9781 20.0546 58.8419C20.3289 58.6261 20.5346 58.4671 20.6603 58.3081C20.3746 58.1718 19.7917 57.8084 19.4032 57.6834C19.1061 57.5926 18.8318 57.5358 18.5918 57.4904C18.5461 57.2291 18.5118 56.9679 18.4661 56.7067C18.1118 56.2978 17.7576 55.889 17.3919 55.4801Z",
    fill: "url(#paint25_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3691 56.1501C17.3691 56.1501 17.4719 57.1382 18.4433 57.3199C19.3118 57.479 19.9632 55.3892 19.5175 54.8554C19.369 54.6737 19.0033 54.5033 18.6833 54.5147C18.4547 54.526 17.7005 54.81 17.5976 55.5596C17.4491 55.4006 17.2548 55.3551 17.1634 55.4233C17.0491 55.5028 17.1062 55.7526 17.1176 55.8094C17.1862 55.9911 17.3119 56.1047 17.3691 56.1501Z",
    fill: "url(#paint26_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3057 60.9202L28.0772 70.2672C28.0658 70.5398 27.8829 70.7783 27.5743 70.8805L21.3232 72.9589C20.8318 73.1179 20.329 72.7431 20.3518 72.2206L20.7975 63.4529C20.8089 63.1803 21.0032 62.9531 21.3004 62.8509L27.7001 60.5795C27.9629 60.4659 28.3057 60.6703 28.3057 60.9202Z",
    fill: "url(#paint27_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.5629 70.8691C27.8715 70.7669 28.0657 70.5398 28.0657 70.2558V70.0514C27.6772 69.9719 27.3229 69.847 27.0486 69.6312C26.1572 68.9498 26.7058 68.0525 25.7687 67.2348C24.7402 66.3262 23.5059 66.9168 22.546 66.0991C21.5289 65.2473 22.3631 64.1456 21.7117 62.6919L21.2889 62.8396C20.9918 62.9418 20.8089 63.1689 20.7861 63.4415L20.3289 72.3001C20.3061 72.7771 20.7632 73.1179 21.2203 72.9702L27.5629 70.8691Z",
    fill: "url(#paint28_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.889 69.3132C18.9461 68.9838 19.0032 68.6545 19.0604 68.3365C17.7119 68.2342 15.8377 68.0639 13.8949 67.7799C13.5863 67.7345 13.2321 67.6777 13.0607 67.3938C12.5807 66.6215 14.2606 65.3382 14.7977 63.3961C15.3805 61.3063 14.5692 58.6715 13.6892 58.5238C11.9178 58.2285 6.94665 67.6209 9.81509 70.4148C11.3807 71.948 15.1748 71.3461 18.889 69.3132Z",
    fill: "url(#paint29_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M19.049 68.3365C19.7689 67.7573 20.8203 68.0071 20.8889 68.0185C21.0831 68.0639 21.3688 68.1661 21.6774 68.3819C21.7117 68.416 22.1574 68.8248 22.0659 69.0065C21.986 69.1542 21.5745 69.1201 21.0374 68.927C20.8317 68.9384 20.5346 68.9724 20.1803 69.0747C19.5404 69.2564 19.2775 69.5289 19.0147 69.3926C18.8204 69.3018 18.7061 69.0406 18.729 68.8248C18.7518 68.5863 18.9347 68.4387 19.049 68.3365Z",
    fill: "url(#paint30_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.237 66.1105C27.9513 66.0423 27.4485 66.4966 27.4599 66.985C27.4713 67.4052 27.8256 67.8254 28.1342 67.7914C28.317 67.7686 28.4427 67.5642 28.477 67.4961C28.7627 67.0077 28.5798 66.19 28.237 66.1105Z",
    fill: "url(#paint31_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4635 92.5161L65.6183 94.2764C65.3898 94.3105 65.1612 94.3219 64.9326 94.2992L64.0413 94.231L64.1898 75.0827L76.4635 74.6511V92.5161Z",
    fill: "url(#paint32_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6304 75.7868V92.4706C51.6304 93.0725 52.0875 93.5495 52.6932 93.595L64.3955 94.2878C64.864 94.3105 65.2754 93.9243 65.2754 93.436V76.0594C65.2754 75.571 64.8869 75.1735 64.4183 75.1622L52.6246 74.8328C52.0761 74.8101 51.6304 75.2417 51.6304 75.7868Z",
    fill: "url(#paint33_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4636 74.6511L65.2756 75.1735L52.6248 74.8215L65.5956 74.4012L76.4636 74.6511Z",
    fill: "url(#paint34_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6475 74.8214L61.8813 75.0827C62.407 75.094 62.8298 75.5369 62.8298 76.0707C62.8298 76.9566 62.6813 77.8765 62.2813 78.7737C60.9671 81.738 58.0301 81.8402 57.413 84.5546C56.8987 86.8147 58.7043 87.7914 58.8986 90.6875C58.9443 91.4484 58.8872 92.2661 58.6586 93.1406C58.5443 93.6063 58.1101 93.9129 57.6415 93.8902L52.556 93.5835C52.0304 93.5495 51.6304 93.1293 51.6304 92.6068V75.7982C51.6304 75.253 52.0875 74.8101 52.6475 74.8214Z",
    fill: "url(#paint35_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61.173 94.0833L56.8303 93.8335V74.935L61.173 75.06V94.0833Z",
    fill: "url(#paint36_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9787 94.072L56.8303 93.8335V74.935L60.9787 75.06V94.072Z",
    fill: "url(#paint37_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8413 74.4807L56.739 75.1622H61.0817L71.6641 74.5375L68.8413 74.4807Z",
    fill: "url(#paint38_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9437 74.1741C62.658 72.4592 62.4523 71.2099 61.3323 70.0514C60.8523 69.5631 60.3381 69.0293 59.4924 68.893C58.5096 68.734 57.2639 69.1088 56.9211 69.9038C56.6011 70.6534 57.3668 71.1531 57.0354 72.0162C56.704 72.8907 55.7554 72.868 55.6526 73.5722C55.5612 74.1627 56.144 74.8442 56.7382 75.1622C57.7553 75.7073 58.3382 74.935 60.3266 75.06C61.698 75.1508 62.498 75.5824 62.8637 75.1395C63.0465 74.935 63.0237 74.6511 62.9437 74.1741Z",
    fill: "url(#paint39_linear)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M57.4929 73.504C58.7272 73.0384 59.3557 72.0162 59.9043 72.2547C60.3842 72.4705 60.0985 73.3564 60.6585 74.0833C61.1728 74.742 62.1327 74.901 62.9784 74.901C62.9555 74.9805 62.9213 75.06 62.8641 75.1281C62.487 75.5597 61.6985 75.1281 60.3271 75.0486C58.3386 74.9237 57.7558 75.696 56.7387 75.1508C56.2016 74.8556 55.6645 74.265 55.6416 73.7085C56.213 73.788 56.853 73.7539 57.4929 73.504Z",
    fill: "url(#paint40_linear)"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3839 69.9378C69.5611 69.2905 68.6811 70.0173 67.664 69.3018C66.6355 68.575 66.9326 67.4165 66.1326 67.0872C65.207 66.701 63.8242 67.8708 63.1613 68.609C61.4928 70.483 60.7043 73.822 62.03 74.9918C62.5214 75.4347 63.927 75.253 66.7269 74.8669C69.9153 74.4353 70.3724 74.1173 70.681 73.7084C71.5038 72.6181 71.321 70.6761 70.3839 69.9378Z",
    fill: "url(#paint41_linear)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M65.1384 71.3461C65.5955 71.1985 65.8126 71.7209 66.7497 71.9367C66.9212 71.9708 68.5896 72.3229 69.481 71.278C69.8353 70.8691 70.0067 70.3126 69.9839 69.7221C70.1096 69.7675 70.2467 69.8356 70.3724 69.9378C71.3095 70.6761 71.4924 72.6181 70.6695 73.7198C70.361 74.1287 69.9039 74.4353 66.7155 74.8782C63.927 75.2644 62.5214 75.4461 62.0185 75.0032C61.95 74.9464 61.8928 74.8782 61.8357 74.8101C62.5099 74.7874 63.2071 74.6284 63.7213 74.14C64.7041 73.186 64.3613 71.5846 65.1384 71.3461Z",
    fill: "url(#paint42_linear)"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3144 31.823L88.0859 36.5249C88.0859 36.5249 92.84 39.5118 94.4513 39.0121C96.0627 38.5124 96.7598 37.5698 90.3144 31.823Z",
    fill: "url(#paint43_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3605 38.5578C86.3262 38.4556 84.4749 40.5226 80.0522 40.6816C80.0522 40.6816 83.7549 47.2574 85.1606 47.5187C86.5891 47.7685 88.7718 45.4062 86.3605 38.5578Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7607 40.7952C78.6122 40.9769 75.2295 47.9502 73.5724 49.5175C71.9153 51.0848 71.1725 47.053 71.0125 44.9746C70.8525 42.8849 71.2411 38.9553 71.2411 38.9553L78.7607 40.7952Z",
    fill: "url(#paint44_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8427 20.9768C36.8427 20.9768 31.7229 25.3039 29.7573 25.2244C27.7917 25.1449 28.2145 15.9455 28.2145 15.9455L36.8427 20.9768Z",
    fill: "url(#paint45_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6834 15.4799C26.9462 15.6276 23.815 20.4998 21.3579 21.556C18.8895 22.6009 17.2896 13.0495 17.2896 13.0495C17.2896 13.0495 22.7407 13.2198 26.6834 15.4799Z",
    fill: "url(#paint46_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1751 13.1971C13.1751 13.1971 13.678 20.3635 13.0494 22.351C12.4209 24.3385 7.83823 18.5237 5.10693 18.0807C5.10693 18.0694 7.24398 14.2306 13.1751 13.1971Z",
    fill: "url(#paint47_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22707 22.6917L1.39282 27.5526C1.39282 27.5526 5.2555 28.3022 6.44401 28.3704C7.64396 28.4272 8.31821 26.0194 2.22707 22.6917Z",
    fill: "url(#paint48_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60395 14.4237C11.5524 12.8791 14.8208 12.2999 18.1235 12.6633C21.4262 13.0267 24.6032 14.117 27.6202 15.4572C30.7858 16.8541 33.8256 18.535 36.8426 20.2159C40.8996 22.476 44.9108 24.8042 48.9106 27.1551C50.9334 28.3363 52.9447 29.5174 54.9675 30.6986C56.9788 31.8684 58.9673 33.0836 61.0243 34.1739C63.0357 35.2301 65.127 36.1273 67.2526 36.9451C69.2868 37.7401 71.3438 38.5351 73.4238 39.1938C76.9436 40.3068 81.1148 40.9315 84.5661 39.2279C86.006 38.5237 87.0803 37.3539 87.9374 36.0251C88.9773 34.4124 89.6858 32.7656 89.9487 30.8576C90.063 30.0285 90.1658 29.1994 90.3487 28.3817C90.383 28.2454 90.6115 28.2795 90.5887 28.4158C90.383 30.1534 90.4401 31.9706 89.8344 33.6401C89.2859 35.162 88.3945 36.7066 87.3317 37.9218C85.0689 40.534 81.3891 41.2154 78.075 40.9315C76.2122 40.7725 74.3837 40.3182 72.6124 39.7276C70.5096 39.0234 68.4183 38.2284 66.3612 37.4107C64.2813 36.5816 62.2243 35.6844 60.2472 34.6168C58.2016 33.5152 56.2017 32.3 54.2018 31.1188C46.6479 26.6781 39.1625 22.0671 31.38 18.0353C28.4087 16.4907 25.3574 15.0824 22.1233 14.1738C19.0263 13.2993 15.7008 12.8905 12.5352 13.6855C8.95822 14.594 5.70123 16.7292 3.75846 19.8752C2.62709 21.715 2.18139 23.7025 1.91855 25.8263C1.8157 26.7122 1.70142 27.6208 1.75856 28.518C1.8157 29.4607 2.76422 32.652 2.58137 33.4016C2.52423 33.6288 2.12425 33.5833 2.15854 33.3335C2.27282 32.4703 1.1643 29.1994 1.11859 28.3363C1.07287 27.405 1.17573 26.4623 1.27858 25.5311C1.38143 24.543 1.51857 23.5435 1.76998 22.5782C2.68423 19.0574 5.41553 16.0932 8.60395 14.4237Z",
    fill: "#B2B8C1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1144 93.0157L81.2405 94.2877C81.0805 94.3105 80.909 94.3218 80.7376 94.3105L80.0977 94.265L80.2005 80.3638L89.1029 80.0458V93.0157H89.1144Z",
    fill: "url(#paint49_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0925 80.8635V92.9703C71.0925 93.4019 71.4239 93.7539 71.8582 93.788L80.3607 94.2877C80.7035 94.3105 81.0006 94.0265 81.0006 93.6744V81.0566C81.0006 80.7045 80.7264 80.4092 80.3721 80.3979L71.8125 80.1593C71.4125 80.1593 71.0925 80.466 71.0925 80.8635Z",
    fill: "url(#paint50_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1145 80.0344L80.9892 80.4206L71.8125 80.1707L81.2292 79.8641L89.1145 80.0344Z",
    fill: "url(#paint51_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8239 80.1707L78.5322 80.3524C78.9093 80.3638 79.2293 80.6818 79.2293 81.0679C79.2293 81.7153 79.115 82.3854 78.8293 83.0214C77.8693 85.1679 75.7437 85.2474 75.298 87.2235C74.9323 88.8703 76.2351 89.5745 76.3723 91.6756C76.4066 92.2321 76.3608 92.8226 76.2009 93.4586C76.1094 93.788 75.8009 94.0265 75.458 94.0038L71.7668 93.788C71.3897 93.7653 71.0925 93.4586 71.0925 93.0725V80.8748C71.0925 80.4773 71.4239 80.1593 71.8239 80.1707Z",
    fill: "url(#paint52_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0179 94.1515L74.8638 93.9584V80.2502L78.0179 80.3411V94.1515Z",
    fill: "url(#paint53_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8693 94.1401L74.8638 93.9584V80.2502L77.8693 80.3297V94.1401Z",
    fill: "url(#paint54_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5833 79.9095L74.7952 80.4092H77.9493L85.6289 79.9549L83.5833 79.9095Z",
    fill: "url(#paint55_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3091 79.6937C79.1034 78.4444 78.9548 77.5358 78.132 76.6954C77.7891 76.3433 77.412 75.9572 76.7949 75.855C76.0864 75.7414 75.1721 76.014 74.9321 76.5932C74.6921 77.1383 75.2521 77.5018 75.0121 78.1264C74.7721 78.7624 74.0864 78.7397 74.0065 79.2508C73.9379 79.6823 74.3721 80.1707 74.795 80.4092C75.5378 80.8067 75.9607 80.2502 77.4006 80.3411C78.3948 80.3978 78.9777 80.7158 79.2405 80.3978C79.3776 80.2502 79.3548 80.0344 79.3091 79.6937Z",
    fill: "url(#paint56_linear)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M75.3439 79.2054C76.2353 78.8646 76.6924 78.1264 77.0924 78.2968C77.4466 78.4558 77.2295 79.1031 77.6409 79.6256C78.018 80.1026 78.7151 80.2275 79.3208 80.2275C79.3094 80.2843 79.2751 80.3411 79.2408 80.3865C78.9666 80.7045 78.3952 80.3865 77.4009 80.3297C75.9496 80.2389 75.5381 80.7954 74.7953 80.3979C74.4068 80.1821 74.0182 79.7619 73.9954 79.353C74.4182 79.4098 74.8868 79.3871 75.3439 79.2054Z",
    fill: "url(#paint57_linear)"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7033 76.6159C84.0976 76.1502 83.4691 76.6727 82.7263 76.1502C81.972 75.6278 82.1892 74.7874 81.6178 74.5489C80.9435 74.2763 79.9378 75.1167 79.4693 75.6505C78.2579 77.0134 77.6865 79.4325 78.6465 80.2843C79.0122 80.6023 80.0293 80.4773 82.052 80.1934C84.3719 79.8754 84.7033 79.6483 84.9205 79.353C85.5147 78.5693 85.3776 77.1497 84.7033 76.6159Z",
    fill: "url(#paint58_linear)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.8978 77.6381C81.2292 77.5358 81.3892 77.9106 82.0749 78.0696C82.2006 78.0923 83.4119 78.3536 84.0633 77.5926C84.3262 77.2973 84.4405 76.8885 84.429 76.4683C84.5205 76.5023 84.6119 76.5478 84.7147 76.6273C85.4004 77.1611 85.5261 78.5693 84.9319 79.3757C84.7147 79.671 84.3719 79.8981 82.0634 80.2161C80.0407 80.4887 79.0122 80.625 78.6579 80.307C78.6122 80.2616 78.5665 80.2161 78.5208 80.1707C79.0122 80.1594 79.515 80.0344 79.8807 79.6823C80.5778 78.9782 80.3264 77.8198 80.8978 77.6381Z",
    fill: "url(#paint59_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 90.6415,
    y1: 42.8634,
    x2: 43.1086,
    y2: 77.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 62.9648,
    y1: 1.45208,
    x2: 53.2414,
    y2: 69.9214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 79.3334,
    y1: 14.2163,
    x2: 52.8999,
    y2: 72.3342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 20.5635,
    y1: 54.3235,
    x2: 73.8179,
    y2: 54.3235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 74.7502,
    y1: 43.4231,
    x2: 36.7322,
    y2: 54.2793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 35.6721,
    y1: 31.5962,
    x2: 43.0968,
    y2: 31.5962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 45.4529,
    y1: 29.5387,
    x2: 71.5017,
    y2: 29.5387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 35.6277,
    y1: 47.7375,
    x2: 43.0608,
    y2: 47.7375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 45.4193,
    y1: 45.2806,
    x2: 71.4962,
    y2: 45.2806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 35.5831,
    y1: 63.9133,
    x2: 43.0247,
    y2: 63.9133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 45.3859,
    y1: 61.0557,
    x2: 71.491,
    y2: 61.0557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 71.143,
    y1: 106.858,
    x2: -21.6776,
    y2: 68.0734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999605,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#371B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4803,
    stopColor: "#462150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7186,
    stopColor: "#612A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9736,
    stopColor: "#853774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 71.1706,
    y1: 106.792,
    x2: -21.6501,
    y2: 68.0072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999605,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#371B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4803,
    stopColor: "#462150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7186,
    stopColor: "#612A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9736,
    stopColor: "#853774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: -19.6254,
    y1: 61.7172,
    x2: 47.596,
    y2: 104.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 22.5675,
    y1: 49.9922,
    x2: -2.86716,
    y2: 67.3762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 23.0851,
    y1: 60.028,
    x2: 23.7358,
    y2: 70.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 33.8606,
    y1: 89.8282,
    x2: 30.4216,
    y2: 89.8282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 32.2386,
    y1: 91.1751,
    x2: 27.1651,
    y2: 75.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 33.3133,
    y1: 83.5528,
    x2: 31.2102,
    y2: 83.5528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 34.532,
    y1: 89.292,
    x2: 31.136,
    y2: 79.0404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 30.3003,
    y1: 72.0418,
    x2: 27.7695,
    y2: 86.7641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 26.6828,
    y1: 89.4836,
    x2: 23.0816,
    y2: 78.0153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 26.6823,
    y1: 89.4837,
    x2: 23.0811,
    y2: 78.0154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 21.5576,
    y1: 70.5564,
    x2: 19.0326,
    y2: 85.2448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 25.2525,
    y1: 61.4404,
    x2: 2.58406,
    y2: 69.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 17.4901,
    y1: 60.9677,
    x2: 18.9694,
    y2: 54.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 18.5048,
    y1: 54.9518,
    x2: 16.8096,
    y2: 63.7378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 28.2688,
    y1: 63.4092,
    x2: 21.5553,
    y2: 69.4463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 27.5263,
    y1: 64.0765,
    x2: 21.3452,
    y2: 69.6349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 11.3801,
    y1: 61.921,
    x2: 15.0352,
    y2: 71.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 21.0306,
    y1: 67.9701,
    x2: 18.4144,
    y2: 71.6478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 27.683,
    y1: 66.3867,
    x2: 29.3077,
    y2: 68.6706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 51.3007,
    y1: 77.7705,
    x2: 78.129,
    y2: 87.3314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 54.3914,
    y1: 85.7485,
    x2: 62.4672,
    y2: 83.3732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 62.8234,
    y1: 68.7096,
    x2: 64.871,
    y2: 75.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 51.6343,
    y1: 84.3527,
    x2: 62.8319,
    y2: 84.3527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 60.6419,
    y1: 76.3109,
    x2: 55.3963,
    y2: 102.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 59.837,
    y1: 84.5805,
    x2: 50.4364,
    y2: 83.1816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 66.1574,
    y1: 75.138,
    x2: 46.212,
    y2: 72.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 56.0441,
    y1: 69.5966,
    x2: 60.9553,
    y2: 74.7362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 55.2485,
    y1: 70.3573,
    x2: 60.1598,
    y2: 75.4969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 67.7246,
    y1: 71.6333,
    x2: 54.5999,
    y2: 69.6802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 67.5718,
    y1: 72.6596,
    x2: 54.4473,
    y2: 70.7065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 95.6278,
    y1: 38.1193,
    x2: 88.9677,
    y2: 33.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 67.1534,
    y1: 57.773,
    x2: 78.7453,
    y2: 30.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 33.1171,
    y1: 17.4709,
    x2: 40.5121,
    y2: 5.02392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 13.1882,
    y1: 34.4076,
    x2: 24.7801,
    y2: 7.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 14.9335,
    y1: 19.3578,
    x2: 7.26728,
    y2: 14.5908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 3.5736,
    y1: 30.6655,
    x2: 12.5309,
    y2: -12.1344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 70.8486,
    y1: 82.304,
    x2: 90.3243,
    y2: 89.2447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 73.0924,
    y1: 88.0956,
    x2: 78.955,
    y2: 86.3712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 79.2135,
    y1: 75.7264,
    x2: 80.6999,
    y2: 80.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 71.6289,
    y1: 81.1502,
    x2: 81.1173,
    y2: 97.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 77.6298,
    y1: 81.2444,
    x2: 73.8217,
    y2: 100.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 77.0455,
    y1: 87.2476,
    x2: 70.2212,
    y2: 86.2321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 81.6336,
    y1: 80.393,
    x2: 67.1544,
    y2: 78.2384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 74.2923,
    y1: 76.3703,
    x2: 77.8575,
    y2: 80.1013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 73.7147,
    y1: 76.9224,
    x2: 77.2801,
    y2: 80.6535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 82.7715,
    y1: 77.8487,
    x2: 73.2438,
    y2: 76.4309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 82.6606,
    y1: 78.5938,
    x2: 73.1329,
    y2: 77.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBirthdays, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/birthdays.d6238dc3.svg";
export { ForwardRef as ReactComponent };